import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FileUploader, FileUploaderOptions, FileUploadModule } from 'ng2-file-upload';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { Router } from '@angular/router';
import { TranslationService, I18nModule } from '@spartacus/core';
import { CommonconfirmpopupComponent } from 'src/app/modules/commonconfirmpopup/commonconfirmpopup.component';
import { NgIf, NgFor, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-attatchment-modal',
    templateUrl: './attatchment-modal.component.html',
    styleUrl: './attatchment-modal.component.scss',
    imports: [NgIf, FileUploadModule, NgFor, DecimalPipe, I18nModule]
})
export class AttatchmentModalComponent implements OnInit{
  @Input() code: any;
  @Input() shipData:any;
  @Input() batchScreenData:any;
  @Input() fromComponent:string;
  @Input() batchDeliveryData:any;
  @Output() fileadded = new EventEmitter<string>();
  data :{};
  selected = false;
  isHidden = false;
  arrayBuffer!: any;
  fileArray = [];
  base64: any;
  enableLoader: boolean = false;
  constructor(private translationService: TranslationService,private router: Router,public activeModal: NgbActiveModal, 
    private customProfileService: CustomProfileService, private toastrService: ToastrService, private modalService:NgbModal) { }

  ngOnInit(): void {
  }

  public uploader: FileUploader = new FileUploader({
    url: ``,
    disableMultipart: false,
    autoUpload: true,
    method: 'post',
    itemAlias: 'attachment',
    allowedFileType: ['xls', 'xlsx','pdf','jpeg','png'],
    maxFileSize:10485760,
  });

  public onFileSelected(event: EventEmitter<File[]>) {
    
    this.enableLoader = true;
    const file: File = event[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {

      this.base64 = reader.result
      const words = this.base64.split(',')[1]
      const filedata = {
        fileInBase64: words,
        mime: file.type,
        name: file.name,
        size: file.size.toString()
      }
    let fileformatmessage = '';
    let errorMessage='';
    let fileexceedmsg=''
    this.translationService.translate('shipment.pdf').subscribe(res=>{
      fileexceedmsg = res;
    })
    this.translationService.translate('shipment.fileformatmsg').subscribe(res=>{
      fileformatmessage = res;
    })
    if((filedata.mime == 'application/pdf' || filedata.mime == 'image/jpeg' || filedata.mime == 'image/png'
       || filedata.mime == 'application/vnd.ms-excel' || filedata.mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && file.size < 10485760){
      this.fileArray.push(filedata);
      
    }
    else if(filedata.mime != 'application/jpeg' && filedata.mime != 'image/pdf' && filedata.mime != 'image/png' && filedata.mime != 'application/vnd.ms-excel' && filedata.mime != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
      this.toastrService.show(fileformatmessage);
    }
    else if(file.size > 10485760){
      
      this.toastrService.show(fileexceedmsg);
    }
    this.enableLoader = false;
  }
  }

  hoverFileShow(param): void {
    this.selected = true;
    const hover = document.getElementById('remove' + param)
    if(hover) {hover.style.display = 'block'}
  }

  hoverFileHide(param): void {
    const hover = document.getElementById('remove' + param)
    if(hover) {hover.style.display = 'none'}
  }

  hoverFileShow1(param): void {
    this.isHidden = true;
    const hover = document.getElementById('hover' + param)
    if(hover) {hover.style.display = 'block'}
  }

  hoverFileHide1(param): void {
    const hover = document.getElementById('hover' + param)
    if(hover) {hover.style.display = 'none'}
  }

  removeFile(i: any) {
    const ModalRef = this.modalService.open(CommonconfirmpopupComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.from='DeleteConfirm';
    ModalRef.result.then(res=>{
      if(res=='Yes'){
        this.uploader.queue.splice(i, 1);
        this.fileArray.splice(i, 1);
      }
    })
  }

  save() {
    if (this.fromComponent == 'shipmentdetails') {
      this.data = {
        nominationKey: this.shipData.nominationKey,
        nominationKeyItem: this.shipData.nominationItemNumber,
        files: this.fileArray
      }
      let toastShown = false;
      this.enableLoader = true;
      this.customProfileService.uploaddocument(this.shipData.nominationNumber, this.data).subscribe((res) => {
        this.enableLoader = false;
        if (res) {
          this.activeModal.close('success');
          this.toastrService.show(res.success);
        } else {
          //this.toastrService.show(res.error);
          this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
            if (!toastShown) {
              this.toastrService.show(res);
              toastShown = true;
            }
          })
        }
      },
        err => {
          this.enableLoader = false;
          this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
            if (!toastShown) {
              this.toastrService.show(res);
              toastShown = true;
            }
          })
          //this.toastrService.show("Sorry something went wrong, please try again!");
        })
    }
    else if (this.fromComponent == 'batchesScreendetails') {
      this.data = {
        files: this.fileArray
      }
      let toastShown = false;
      this.enableLoader = true;
      if(this.fileArray.length === 0){
        this.enableLoader = false;
           this.translationService.translate('shipment.uploadText').subscribe(res => {
            if (!toastShown) {
              this.toastrService.show(res);
              toastShown = true;
            }
          })
      }else{
        this.customProfileService.uploadScreeningDocs(this.batchScreenData.code, this.data).subscribe({
        next: res => {
          this.enableLoader = false;
          if (res) {
            this.activeModal.close('success');
            this.toastrService.show(res.success);
          } else {
            this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
              if (!toastShown) {
                this.toastrService.show(res);
                toastShown = true;
              }
            })
          }
        },
        error: err => {
          this.enableLoader = false;
          this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
            if (!toastShown) {
              this.toastrService.show(res);
              toastShown = true;
            }
          })
        }
      })
      }
      
    }else if(this.fromComponent == 'batchDeliveryDetails'){
      this.data = {
        files: this.fileArray
      }
      let toastShown = false;
      this.enableLoader = true;
      if(this.fileArray.length === 0){
        this.enableLoader = false;
         this.translationService.translate('shipment.uploadText').subscribe(res => {
            if (!toastShown) {
              this.toastrService.show(res);
              toastShown = true;
            }
          })
      }else{
         this.customProfileService.uploadDeliveryDocs(this.batchDeliveryData.code, this.data).subscribe({
        next: res => {
          this.enableLoader = false;
          if (res) {
            this.activeModal.close('success');
            this.toastrService.show(res.message);
          } else {
            this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
              if (!toastShown) {
                this.toastrService.show(res);
                toastShown = true;
              }
            })
          }
        },
        error: err => {
          this.enableLoader = false;
          this.translationService.translate('shipment.erroroccuredmessage').subscribe(res => {
            if (!toastShown) {
              this.toastrService.show(res);
              toastShown = true;
            }
          })
        }
      })
      }
     
    }

  }

  deleteFile(i) {
    const ModalRef = this.modalService.open(CommonconfirmpopupComponent, { centered: true, size: 'md' });
    ModalRef.componentInstance.from='DeleteConfirm';
    ModalRef.result.then(res=>{
      if(res=='Yes'){
        if(this.fromComponent === 'batchesScreendetails'){
          
          this.data = {
            documentId:this.batchScreenData.screeningDocuments[i].documentId
          }
          let toastShown=false;
          this.customProfileService.removeBatchScreeningdocument(this.batchScreenData.code, this.data).subscribe((res) => {
            this.enableLoader = false;
            this.activeModal.close();
            this.batchScreenData.screeningDocuments.splice(i, 1);
            if (res) {
              this.toastrService.show(res.success);
            } else {
             // this.toastrService.show(res.error);
              this.translationService.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
                
              })
            }
          },
            err => {
              this.enableLoader = false;
              console.log("err", err);
              //this.toastrService.show("Sorry something went wrong, please try again!");
              this.enableLoader = false;
              this.translationService.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
              })
            })
        }else if(this.fromComponent == 'batchDeliveryDetails'){
           this.data = {
            documentId:this.batchDeliveryData.documents[i].documentId
          }
          let toastShown=false;
          this.customProfileService.removeBatchDeliverydocument(this.batchDeliveryData.code, this.data).subscribe((res) => {
            this.enableLoader = false;
            this.activeModal.close();
            this.batchDeliveryData.documents.splice(i, 1);
            if (res) {
              this.toastrService.show(res.success);
            } else {
             // this.toastrService.show(res.error);
              this.translationService.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
                
              })
            }
          },
            err => {
              this.enableLoader = false;
              console.log("err", err);
              //this.toastrService.show("Sorry something went wrong, please try again!");
              this.enableLoader = false;
              this.translationService.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
              })
            })
        }else{
          this.data = {
            nominationKey :this.shipData.nominationKey,
            nominationKeyItem: this.shipData.nominationItemNumber,
            documentId:this.shipData.attachments[i].documentId
          }
          let toastShown=false;
          this.customProfileService.removedocument(this.shipData.nominationNumber, this.data).subscribe((res) => {
            this.enableLoader = false;
            this.activeModal.close();
            this.shipData.attachments.splice(i, 1);
            if (res) {
              this.toastrService.show(res.success);
            } else {
             // this.toastrService.show(res.error);
              this.translationService.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
                
              })
            }
          },
            err => {
              this.enableLoader = false;
              console.log("err", err);
              //this.toastrService.show("Sorry something went wrong, please try again!");
              this.enableLoader = false;
              this.translationService.translate('shipment.erroroccuredmessage').subscribe(res=>{
                if(!toastShown){
                  this.toastrService.show(res);
                  toastShown=true;
                }
              })
            })
        }
       
      }
    })
  }

    
  
}
